import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class DocumentStatisticsService {

  constructor(
    private http: HttpClient
  ) { }


  getCompanyWiseStats(queryParams?: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.DOCUMENT_STATISTICS, { params })
      .pipe(catchError(errorHandl));
  }

  getOverview(queryParams?: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.DOCUMENT_STATISTICS + '/overview', { params })
      .pipe(catchError(errorHandl));
  }

  getExpiredDocuments(queryParams?: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.DOCUMENT_STATISTICS + '/details', { params })
      .pipe(catchError(errorHandl));
  }

}
